import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { FaRegPlayCircle } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";
import GalleryLibraryModal from "./GalleryLibraryModal";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { deleteTeamVideoRequest } from "../../store/TeamVideo/teamVideoActions"; // Adjust path as needed
import { deleteServiceVideoRequest } from "../../store/ServiceVideo/serviceVideosActions"; // Adjust path as needed
const GalleryPickerField = ({
  label,
  church,
  rowData,
  name,
  handleChange,
  initialSelectedVideoId
}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedVideos, setSelectedVideos] = useState([]);

  // Initialize selectedImages from rowData.programVideos when component mounts or rowData changes
  useEffect(() => {
    if (rowData?.programVideos && rowData.programVideos.length > 0) {
      const normalizedVideos = rowData.programVideos.map(video => {
        const videoData = video.video || {};
        const galleryData = videoData.gallery || {};

        return {
          id: videoData._id || video.videoObjId || video.programvideoObjId,
          videoName: videoData.videoName || videoData.name || "Untitled Video",
          videoDescription: videoData.videoDescription || "",
          youtubeurl: videoData.youtubeurl || "",
          thumbnailId: galleryData._id || videoData.tumbnailGalleryObjId || null,
          thumbnailUrl: galleryData.imageUrl || "",
          thumbnailName: galleryData.imageName || videoData.videoName || "",
          galleryId: galleryData._id || null,
          fullItem: videoData,
          // Keep original data for reference
          originalVideoData: video,
        };
      });

      setSelectedImages(normalizedVideos);
          }
    else if(rowData?.membervideos && rowData.membervideos.length > 0){
      const normalizedVideos = rowData.membervideos.map(video => {
        const videoData = video.video || {};
        const galleryData = videoData.gallery || {};

        return {
          id: videoData._id || video.videoObjId || video.programvideoObjId,
          videoName: videoData.videoName || videoData.name || "Untitled Video",
          videoDescription: videoData.videoDescription || "",
          youtubeurl: videoData.youtubeurl || "",
          thumbnailId: galleryData._id || videoData.tumbnailGalleryObjId || null,
          thumbnailUrl: galleryData.imageUrl || "",
          thumbnailName: galleryData.imageName || videoData.videoName || "",
          galleryId: galleryData._id || null,
          fullItem: videoData,
          // Keep original data for reference
          originalVideoData: video,
        };
      });

      setSelectedImages(normalizedVideos);
          }

    else if(rowData?.servicevideos && rowData.servicevideos.length > 0){
      const normalizedVideos = rowData.servicevideos.map(video => {
        const videoData = video.video || {};
        const galleryData = videoData.gallery || {};

        return {
          id: videoData._id || video.videoObjId || video.programvideoObjId,
          videoName: videoData.videoName || videoData.name || "Untitled Video",
          videoDescription: videoData.videoDescription || "",
          youtubeurl: videoData.youtubeurl || "",
          thumbnailId: galleryData._id || videoData.tumbnailGalleryObjId || null,
          thumbnailUrl: galleryData.imageUrl || "",
          thumbnailName: galleryData.imageName || videoData.videoName || "",
          galleryId: galleryData._id || null,
          fullItem: videoData,
          // Keep original data for reference
          originalVideoData: video,
        };
      });

      setSelectedImages(normalizedVideos);
          }
    else {
      // Clear if no programVideos
      setSelectedImages([]);
    }
  }, [rowData]);

  // Handle selection coming from modal: we expect normalized video object
  const handleImageSelect = (imgSet) => {
    const normalized = {
      id: imgSet.id ?? imgSet._id ?? imgSet.fullItem?._id,
      videoName: imgSet.videoName ?? imgSet.fullItem?.videoName ?? imgSet.name,
      videoDescription: imgSet.videoDescription ?? imgSet.fullItem?.videoDescription ?? "",
      youtubeurl: imgSet.youtubeurl ?? imgSet.fullItem?.youtubeurl ?? "",
      thumbnailId: imgSet.thumbnailId ?? imgSet.fullItem?.gallery?._id ?? imgSet.tumbnailGalleryObjId ?? null,
      thumbnailUrl: imgSet.thumbnailUrl ?? imgSet.fullItem?.gallery?.imageUrl ?? imgSet.url ?? "",
      thumbnailName: imgSet.thumbnailName ?? imgSet.fullItem?.gallery?.imageName ?? imgSet.name ?? "",
      galleryId: imgSet.galleryId ?? imgSet.fullItem?.gallery?._id ?? null,
      fullItem: imgSet.fullItem ?? imgSet,
    };

    // Check if already exists
    if (!selectedImages.some((i) => i.id === normalized.id)) {
      const updated = [...selectedImages, normalized];
            setSelectedImages(updated);

      if (typeof handleChange === "function") {
        handleChange({ target: { name, value: updated } });
      }
    } else {
      toast.info("This video is already selected.");
    }

    setShowModal(false);
  };

  // Delete handler with API call
  const handleDelete = (video, index) => {

    // Determine if we're in a service context
    const isServiceContext = window.location.href.toLowerCase().includes("service") ||
                           rowData?.serviceObjId ||
                           video?.originalVideoData?.serviceVideoObjId;

    let payload;
    let dispatchAction;

    if (isServiceContext) {
      // Service video deletion payload
      payload = {
        _id: church?._id, // Church Obj id
        serviceObjId: rowData?.serviceObjId, // Service Object ID
        serviceVideoObjId: video?.originalVideoData?.serviceVideoObjId, // Service Video Object ID
        videoObjId: video?.id, // Video Object ID
      };

      dispatchAction = deleteServiceVideoRequest;

      // Validate service video payload
      if (!payload._id || !payload.serviceObjId || !payload.serviceVideoObjId || !payload.videoObjId) {
        toast.error("Missing data for service video delete");
                return;
      }
    } else {
      // Team video deletion payload (original logic)
      payload = {
        _id: video?.fullItem?.churchObjId || church?._id,
        memberObjId: rowData?.memberObjId,
        memberVideoObjId: video?.originalVideoData?.memberVideoObjId,
      };

      dispatchAction = deleteTeamVideoRequest;

      // Validate team video payload
      if (!payload._id || !payload.memberObjId || !payload.memberVideoObjId) {
        toast.error("Missing data for delete");
                return;
      }
    }

    dispatch(
      dispatchAction(payload, (res) => {
        if (res?.type === 1) {
          // ✅ REMOVE FROM UI STATE
          const updated = selectedImages.filter((_, i) => i !== index);
          setSelectedImages(updated);

          // ✅ UPDATE PARENT FORM
          if (typeof handleChange === "function") {
            handleChange({ target: { name, value: updated } });
          }

          toast.success(isServiceContext ? "Service video deleted successfully" : "Video deleted successfully");
        } else {
          toast.error(res?.error || (isServiceContext ? "Service video delete failed" : "Delete failed"));
        }
      })
    );
  };


  return (
    <div className="flex flex-col gap-2 my-4 w-full max-w-[99%]">
      <div className="flex items-center justify-between">
        <label className="text-[12px] text-greyish font-medium">{label}</label>
        <button
          onClick={() => setShowModal(true)}
          className="text-white hover:text-gray-300 flex items-center"
        >
          <FaRegPlayCircle size={18} className="mr-2" /> Select Video
        </button>
      </div>

      {/* Selected items */}
      <div className="bg-[#1b1b1b] border border-[#333] rounded-lg p-3 w-full flex flex-col gap-2">
        {selectedImages.length > 0 ? (
          selectedImages.map((imgSet, index) => (
            <div
              key={`${imgSet.id || imgSet.videoName || "video"}-${index}`}
              className="flex items-center justify-between bg-[#131313] border border-[#333] rounded-lg px-3 py-2"
            >
              <div className="flex items-center gap-3">
                {/* Video icon + name */}
                <FaRegPlayCircle className="text-white w-5 h-5" />
                <div className="flex flex-col">
                  <span className="text-white text-sm font-medium truncate">
                    {imgSet.videoName || imgSet.thumbnailName || imgSet.name || "Untitled Video"}
                  </span>
                  {/* {imgSet.youtubeurl && (
                    <span className="text-xs text-gray-400 truncate max-w-xs">
                      {imgSet.youtubeurl}
                    </span>
                  )} */}
                  {/* {imgSet.originalVideoData?.programvideoObjId && (
                    <span className="text-xs text-green-400">
                      ✓ Saved to program
                    </span>
                  )} */}
                </div>
              </div>
              <button
                onClick={() => handleDelete(imgSet, index)}
                className="text-white hover:text-red-500 rounded-full p-1"
                title="Remove video"
              >
                <AiOutlineDelete size={18} />
              </button>
            </div>
          ))
        ) : (
          <span className="text-greyish text-sm">No video selected</span>
        )}
      </div>

      {/* Debug info (optional) */}
      {rowData?.programVideos && (
        <div className="text-xs text-gray-500">
          Found {rowData.programVideos.length} video(s) in program data
        </div>
      )}

      {/* Modal */}
      {showModal && church?._id && (
        <GalleryLibraryModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          church={church}
          handleGallerySelect={handleImageSelect}
        />
      )}
    </div>
  );
};

export default GalleryPickerField;